/**
 * Карта v3 — картинки устройств.
 *
 * Источники по приоритету: своя картинка устройства → картинка его типа →
 * встроенная векторная иконка. Грузим лениво и один раз: карта перерисовывается
 * десятки раз в секунду, создавать Image на каждый кадр нельзя.
 *
 * Когда картинка догрузилась, дёргаем onReady — движок помечает кадр грязным
 * и перерисовывает. Без этого картинка появилась бы только после следующего
 * движения мыши.
 */

const cache = new Map();     // url -> { img, state: 'loading'|'ok'|'fail' }
let onReady = null;

export function setSpriteListener(fn) { onReady = fn; }

/** URL картинки для устройства или null, если её нет. */
export function spriteUrl(node) {
  if (node.imagePath) return node.imagePath;
  if (node.typeImage && node.typeId) return `/api/device-types/${node.typeId}/image`;
  return null;
}

/**
 * Картинка, готовая к отрисовке, либо null.
 * Первый вызов ставит загрузку в очередь и возвращает null — это нормально,
 * кадр отрисуется с векторной иконкой и обновится, когда картинка приедет.
 */
export function getSprite(url) {
  if (!url) return null;
  const hit = cache.get(url);
  if (hit) return hit.state === 'ok' ? hit.img : null;

  const img = new Image();
  const rec = { img, state: 'loading' };
  cache.set(url, rec);
  img.onload = () => {
    rec.state = img.naturalWidth > 0 ? 'ok' : 'fail';
    if (onReady) onReady();
  };
  img.onerror = () => {
    rec.state = 'fail';        // молча падаем на векторную иконку
    if (onReady) onReady();
  };
  img.src = url;
  return null;
}

/** Сбросить кеш конкретной картинки — после загрузки новой поверх старой. */
export function invalidateSprite(url) {
  if (!url) return;
  cache.delete(url);
  // тот же адрес с новым содержимым: заставим браузер перечитать
  const bust = `${url}${url.includes('?') ? '&' : '?'}v=${Date.now()}`;
  cache.delete(bust);
}

export function spriteStats() {
  let ok = 0, loading = 0, fail = 0;
  for (const r of cache.values()) {
    if (r.state === 'ok') ok++; else if (r.state === 'loading') loading++; else fail++;
  }
  return { ok, loading, fail, total: cache.size };
}
